import DeviceConfig from '@devices/config';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

interface Props {
  disableMargin?: boolean;
  disableWidth?: boolean;
  displayFilter?: boolean;
}

const ChannelLogo = styled.img<Props>`
  height: 100%;
  min-height: ${90 * Screen.widthRatio}px;
  margin: 0 ${(props) => (props.disableMargin ? 0 : 8 * Screen.widthRatio)}px 0
    ${(props) => (props.disableMargin ? 0 : 8 * Screen.widthRatio)}px;
  width: ${(props) => (props.disableWidth ? null : '100%')};

  ${(props) =>
    props.displayFilter && !DeviceConfig.capabilities.disableAnimations
      ? `filter: drop-shadow(
    ${5 * Screen.widthRatio}px ${5 * Screen.widthRatio}px
      ${5 * Screen.widthRatio}px #000000
  );
  -webkit-filter: drop-shadow(
    ${5 * Screen.widthRatio}px ${5 * Screen.widthRatio}px
      ${5 * Screen.widthRatio}px #000000
  );`
      : ''}
`;

export default withImage(ChannelLogo, true);
